import React from 'react'
import { Tabs as CoreTabs, Tab as CoreTab } from '@blueprintjs/core'

export const Tabs = ({ ...props }) => (
    <CoreTabs 
        large
        {...props} 
    />
)

export const Tab = CoreTab